import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  UpdateProjectRenovationHouseDocument,
  CO2CalculationsDocument,
  ProjectPlanDocument,
  type UpdateProjectRenovationHouseInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';

const useUpdateProjectRenovationHouseMutation = () => {
  const [updateProjectRenovationHouseMutation] = useMutation(UpdateProjectRenovationHouseDocument);

  const mutate = useCallback(
    async (projectId: string, formData: UpdateProjectRenovationHouseInput) => {
      try {
        const res = await updateProjectRenovationHouseMutation({
          variables: { projectId, formData: { ...formData } },
          refetchQueries: [
            { query: ProjectPlanDocument, variables: { projectId } },
            { query: CO2CalculationsDocument, variables: { projectId } },
          ],
          awaitRefetchQueries: true,
        });
        const { updateProjectRenovationHouse: result } = requireValue(
          res.data,
          'updateProjectRenovationHouse',
        );

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [updateProjectRenovationHouseMutation],
  );
  return mutate;
};

export default useUpdateProjectRenovationHouseMutation;
